import { getScreenInfo } from '../helpers/get-screen-info';

export default {
    install(Vue) {
        /*
         * TODO: Во всех Vue компонентах используется $screen, но при изменении размеров окна браузера..
         * TODO: ..не обновится $screen => нужно вешать глобальное событие window.resize, чтобы обновлять $screen (?)
         */
        const SearchBoosterApiConfig = window['searchbooster'].api.configuration;
        Vue.prototype.$screen = getScreenInfo(SearchBoosterApiConfig.mode);
    },
};
